import { styled } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import React, { FunctionComponent } from "react";
import Button, { ButtonProps } from "../button/Button";
import { useLocale } from "designSystem/locale";
import { HOVER } from "designSystem/theme";

const PREFIX = "DataGridNewCard";

const classes = {
	root: `${PREFIX}root`,
};

const StyledButton = styled(Button)(({
	theme: { palette },
}) => ({
	[`&.${classes.root}`]: {
		backgroundColor: palette.grey[100],
		borderColor: palette.grey[600],
		borderRadius: 3,
		borderStyle: "dashed",
		borderWidth: 1,
		height: "100%",
		padding: 0,
		width: "100%",

		[HOVER]: {
			backgroundColor: palette.HighlightSelected,
			borderColor: palette.FocusPrimary,
		},
	},
}));

export interface DataGridNewCardProps extends Pick<ButtonProps, "onClick"> {
	/** minimum height of card in case there are no other results in grid */
	minHeight: number;

	/** type of node to create */
	nodeType: string;
}

const DataGridNewCard: FunctionComponent<DataGridNewCardProps> = (props) => {
	const { minHeight, nodeType, onClick } = props;
	const loc = useLocale();


	return (
		<StyledButton
			className={classes.root}
			design="link"
			onClick={onClick}
			res={loc.resources.RES_NEW_OF_TYPE}
			resParams={[loc.type(nodeType)]}
			startIcon={<AddIcon />}
			style={{ minHeight }}
		/>
	);
};

export default DataGridNewCard;